module.exports = __webpack_public_path__ + "img/b5492324054ff190792daa40528a560.27117ca5.png";